import { ActionConsts } from '@Definitions/ActionConsts';

interface LabTestState {
  labPreparation: Record<string, string>;
  isLoading: boolean;
}

const INITIAL_STATE_LABTEST: LabTestState = {
  labPreparation: {},
  isLoading: false,
};

export const LabtestReducer = (state: LabTestState = INITIAL_STATE_LABTEST, action: any) => {
  switch (action.type) {
    case ActionConsts.Labtest.GetLabPreparationInit:
      return {
        ...state,
        isLoading: true,
      };
    case ActionConsts.Labtest.GetLabPreparationSuccess:
      return {
        ...state,
        labPreparation: action.labPreparation,
        isLoading: false,
      };
    case ActionConsts.Labtest.GetLabPreparationFail:
      return {
        ...state,
        labPreparation: {},
        isLoading: false,
      };
    default:
      return state;
  }
};

export default LabtestReducer;
